import { useEffect, useState } from "react";

import { getData } from "../../../../../services";
import { PowerConsumptionOverTime } from "../../../../../components/parts";
import { powerConsumptionOverTimeAreas } from "../../../constants";

const defaultPowerConsumptionOverTime = {
  chart_data: [],
  monthly_avg: 0,
  previous_year_consumption: 0,
};

export const PowerConsumptionOverTimeComponent = ({ buildingId, complexId, title }) => {
  const [powerConsumptionOverTime, setPowerConsumptionOverTime] = useState(
    defaultPowerConsumptionOverTime
  );

  let url = `/praas/v2/buildings/properties/consumption-graph/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/consumption-graph/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/consumption-graph/`;
  }

  useEffect(() => {
    getData(url, (data) => {
      const chartData = data.consumption.map((consum) => {
        const date = new Date(consum.date);
        return {
          x: `${date.getUTCFullYear()}-${date.getMonth() + 1}`,
          consumption: consum.kwh,
        };
      });
      setPowerConsumptionOverTime({
        chart_data: chartData,
        monthly_avg: data.monthly_avg,
        previous_year_consumption: data.previous_year_consumption,
      });
    });
  }, [complexId, buildingId]);

  return (
    <PowerConsumptionOverTime
      title={title}
      chartData={powerConsumptionOverTime.chart_data}
      chartAreas={powerConsumptionOverTimeAreas}
      monthlyAvg={powerConsumptionOverTime.monthly_avg}
      previousYearConsumption={powerConsumptionOverTime.previous_year_consumption}
      showToggle={false}
    />
  );
};
